import request from 'services/axios';

export const mahsulCategories = async () => {
  const {data}: {data: IMahsulCategories} = await request.get(
    `/api/v2/farm/mahsulCategories`,
  );
  return data;
};
